import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React from "react";

export default function DeleteAllCart({
  isOpen,
  onClose,
  name,
  img,
  qty,
  handleDelete,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Konfirmasi Delete</ModalHeader>
        <ModalCloseButton />
        <hr />
        <ModalBody>
          <Box py="1">
            <Box py="2">
              <Text fontWeight="600" fontSize="20px" textAlign="center" py="2">
                Apakah anda yakin akan menghapus semua barang pada keranjang ?
              </Text>
            </Box>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Close
          </Button>
          <Button colorScheme="red" onClick={handleDelete}>
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
